import { gql } from '@apollo/client';

const RESOLVE_FLAGGED_STUDY_MUTATION = gql`
  mutation resolveFlaggedStudy($studyId: ID!, $isResolved: Boolean!, $isSkip: Boolean) {
    resolveFlaggedStudy(studyId: $studyId, isResolved: $isResolved, isSkip: $isSkip) {
      isSuccess
      message
    }
  }
`;

export default RESOLVE_FLAGGED_STUDY_MUTATION;
